export const PatientSakhadVisitTable_rowItem = ({ item }: { item: any }) => {
  return (
    <tr>
      <td className="font-12">{item?.fullName}</td>
      <td className="font-12">{item?.consumptionDesc}</td>
      <td className="font-12">{item?.consumptionInstructionDesc}</td>
      <td className="font-12">{item?.count}</td>
      {/* <td className="text-center">
        {item?.emergency ? (
          <span className="badge bg-light-red text-red px-2 py-1">بله</span>
        ) : (
          <span className="badge bg-light-gray text-black px-2 py-1">خیر</span>
        )}
      </td> */}
      <td className="font-12 text-nowrap">{item?.creationDate}</td>
    </tr>
  );
};
